export const MINUTE_STEPS = 30;
export const TIME_CHANGE_DEBOUNCE_DELAY_MS = 1000;
export const TIME_FORMAT = 'HH:mm';

export enum WeekScheduleFormFields {
  Schedule = 'schedule',
}
